module.exports = __webpack_public_path__ + "img/45.23051ef4.jpg";